var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatche(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "white",
    fillOpacity: 0.12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_468_2103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5536 13.4532C20.3799 13.374 20.1912 13.333 20.0003 13.333C19.8094 13.333 19.6207 13.374 19.447 13.4532L13.7336 16.0532C13.6153 16.1054 13.5148 16.1908 13.4441 16.2992C13.3735 16.4075 13.3359 16.534 13.3359 16.6632C13.3359 16.7925 13.3735 16.919 13.4441 17.0273C13.5148 17.1356 13.6153 17.2211 13.7336 17.2732L19.4536 19.8799C19.6273 19.9591 19.816 20.0002 20.007 20.0002C20.1979 20.0002 20.3866 19.9591 20.5603 19.8799L26.2803 17.2799C26.3986 17.2278 26.4992 17.1423 26.5698 17.034C26.6404 16.9257 26.678 16.7992 26.678 16.6699C26.678 16.5406 26.6404 16.4141 26.5698 16.3058C26.4992 16.1975 26.3986 16.1121 26.2803 16.0599L20.5536 13.4532Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.333 20C13.3327 20.1275 13.369 20.2524 13.4375 20.36C13.506 20.4675 13.604 20.5531 13.7197 20.6067L19.453 23.2133C19.6258 23.2916 19.8133 23.3321 20.003 23.3321C20.1927 23.3321 20.3802 23.2916 20.553 23.2133L26.273 20.6133C26.391 20.5603 26.491 20.4741 26.5609 20.3652C26.6307 20.2562 26.6674 20.1294 26.6663 20",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.333 23.3335C13.3327 23.461 13.369 23.5859 13.4375 23.6935C13.506 23.801 13.604 23.8866 13.7197 23.9402L19.453 26.5468C19.6258 26.6251 19.8133 26.6656 20.003 26.6656C20.1927 26.6656 20.3802 26.6251 20.553 26.5468L26.273 23.9468C26.391 23.8938 26.491 23.8076 26.5609 23.6987C26.6307 23.5897 26.6674 23.4629 26.6663 23.3335",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_468_2103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatche);
export default __webpack_public_path__ + "static/media/batche.82d6349537e3f78799d11c94f43cae6a.svg";
export { ForwardRef as ReactComponent };